<div class="col-xl-12">
	<div  mat-dialog-title class="dialog-title">
		<h2>{{data.title}}</h2>
	</div>
	<div mat-dialog-content class="dialog-content">
		<mat-form-field appearance="fill" style="width: 100%;">
			<mat-label>Subject</mat-label>
			<input matInput type="text" [(ngModel)]="subject">
		</mat-form-field>
		<mat-form-field appearance="fill" style="width: 100%;">
			<mat-label>Start Date and Time</mat-label>
			<input matInput type="datetime-local" [(ngModel)]="startdatetime">
		</mat-form-field>
		<mat-form-field appearance="fill" style="width: 100%;">
			<mat-label>End Date and Time</mat-label>
			<input matInput type="datetime-local" [(ngModel)]="enddatetime">
		</mat-form-field>
		<mat-form-field appearance="fill" style="width: 100%;">
			<mat-label>Reminder</mat-label>
			<input matInput type="text" [(ngModel)]="remainder">
		</mat-form-field>
		<mat-form-field appearance="fill" style="width: 100%;">
			<mat-label>Location</mat-label>
			<input matInput type="text" [(ngModel)]="location">
		</mat-form-field>
	</div>
	<div mat-dialog-actions class="dialog-actions">
		<span>
			<button mat-raised-button color="danger" (click)="closeModal(undefined)">Close</button>
			<button mat-raised-button (click)="confirmModal()">Confirm</button>
    </span>
	</div>
	<br/>
</div>
